/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import { ContentState, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import { convertToHTML } from "draft-convert";
import MDEditorRoot from "dashboard-template/components/MDEditor/MDEditorRoot";
import { useMaterialUIController } from "context/ThemeContext";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

interface ITextEditorProps {
  value: string;
  setFieldValue: (val: string) => void;
  readOnly?: boolean;
  addExternal?: boolean;
  setAddExternal?: React.Dispatch<React.SetStateAction<boolean>>;
  editorHeight?: string;
  wrapperHeight?: string;
  inputId?: string;
}

const FormTextEditor = ({
  value,
  setFieldValue,
  readOnly,
  addExternal,
  setAddExternal,
  editorHeight,
  wrapperHeight,
  inputId,
}: ITextEditorProps) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const prepareDraft = (value: string) => {
    const draft = htmlToDraft(value);
    const contentState = ContentState.createFromBlockArray(draft.contentBlocks);
    const editorState = EditorState.createWithContent(contentState);
    return editorState;
  };

  useEffect(() => {
    if (addExternal) {
      const newEditorState = value ? prepareDraft(value) : EditorState.createEmpty();
      setEditorState(newEditorState);
      setAddExternal(false);
    }
  }, [value]);

  const [editorState, setEditorState] = useState(
    value ? prepareDraft(value) : EditorState.createEmpty()
  );

  const onEditorStateChange = (editorState: EditorState) => {
    const forFormik = convertToHTML(editorState.getCurrentContent());
    setFieldValue(forFormik);
    setEditorState(editorState);
  };

  return (
    <MDEditorRoot ownerState={{ darkMode }} id={inputId}>
      <Editor
        readOnly={readOnly}
        editorState={editorState}
        wrapperClassName="custom-wrapper"
        editorClassName="custom-editor"
        onEditorStateChange={onEditorStateChange}
        toolbar={{
          options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history'],
          inline: { options: ['bold', 'italic', 'underline'] },
          list: { options: ['unordered', 'ordered'] },
          textAlign: { options: ['left', 'center', 'right'] },
        }}
      />
    </MDEditorRoot>
  );
};

export default FormTextEditor;
